import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from "./locals/en.json";
import sqTranslation from "./locals/sq.json";

const resources = {
  en: {
    translation: enTranslation,
  },
  sq: {
    translation: sqTranslation,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
